import { render } from "./add_two_secondary.vue?vue&type=template&id=2b4c5019"
import script from "./add_two_secondary.vue?vue&type=script&lang=js"
export * from "./add_two_secondary.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__